export const paths = {
  home: "/",
  orderDetails: "/order-details",
};
